// @flow
import * as Sentry from '@sentry/react'
import { ResourceSessionsContext } from 'components/ResourceFill/providers/ResourceSessionsProvider'
import * as React from 'react'

function useSentryForPatients() {
  const { currentSession } = React.useContext(ResourceSessionsContext) || {}

  React.useEffect(() => {
    if (!currentSession?.customer) return
    const { customer } = currentSession
    if (!customer) return

    const { id, first_name, last_name } = customer
    if (!id || !first_name || !last_name) return

    Sentry.setUser({ id, username: `${first_name} ${last_name}` })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSession?.customer?.id])
}

export default useSentryForPatients
